import React, { Component } from 'react';
import classNames from 'classnames';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import './Table.module.css';

const Table = DisplayComponent(
  class Table extends Component {
    render() {
      const {
        headersTop,
        headersLeft,
        headersBottom,
        tableData,
        classes,
        styleNames,
        styles
      } = this.props;

      const data = JSON.parse(tableData);
      const bottom = [];
      const top = [];

      if (headersBottom) {
        for (let index = 0; index < headersBottom; index++) {
          bottom.unshift(data.pop());
        }
      }
      if (headersTop) {
        for (let index = 0; index < headersTop; index++) {
          top.push(data.shift());
        }
      }

      const renderRow = (row, key) => (
        <tr key={key}>
          {row.map((column, columnIndex) => {
            if (headersLeft && columnIndex < headersLeft) {
              return (
                <th
                  key={columnIndex}
                  scope="row"
                  dangerouslySetInnerHTML={{ __html: column }}
                />
              );
            } else {
              return (
                <td
                  key={columnIndex}
                  dangerouslySetInnerHTML={{ __html: column }}
                />
              );
            }
          })}
        </tr>
      );

      return (
        <div
          className={classes}
          styleName={classNames(styleNames)}
          style={styles}
        >
          <table styleName="data-table">
            {top && (
              <thead>
                {top.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((column, columnIndex) => (
                      <th
                        key={columnIndex}
                        dangerouslySetInnerHTML={{ __html: column }}
                      />
                    ))}
                  </tr>
                ))}
              </thead>
            )}
            <tbody>{data.map(renderRow)}</tbody>
            {bottom && <tfoot>{bottom.map(renderRow)}</tfoot>}
          </table>
        </div>
      );
    }
  }
);

export default Table;
